import classNames from 'classnames';
import React from 'react';
import { ButtonVariant } from '../../button';
import * as S from '../pagination.styles';
export const PageButton = ({ page, label, onClick, className, isActive, isDisabled, testId }) => {
    return (React.createElement(S.Button, { variant: ButtonVariant.DARK, isOutlined: true, className: classNames({
            active: isActive,
        }, className), isDisabled: isDisabled, testId: testId, onClick: () => {
            // Check if there is a onclick function, an page provided, and the button is not disabled.
            if (onClick && page && !isDisabled) {
                onClick(page);
            }
        } }, label || page));
};
//# sourceMappingURL=page-button.js.map